import { Component, OnInit } from '@angular/core';
import { ValidatorService } from '../../../services';
import { Router } from '@angular/router';
import { ValidatorsComponent } from '../validators.component';

@Component({
  selector: 'app-validators-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})

export class ValidatorsListComponent implements OnInit {

  limit = 12;
  data: Array<Object> = [];

  constructor(
    private router: Router,
    private validatorService: ValidatorService,
    public parent: ValidatorsComponent
  ) { }

  ngOnInit() {
    this.validatorService.getAllValidators()
      .subscribe(validators => this.data = validators || []);
  }

  gotoDetails(validatorProvider: any): void {
    console.log(validatorProvider);
    localStorage.setItem('currentValidatorProvider', JSON.stringify(validatorProvider));
    this.router.navigate(['/validators/details']);
  }

  gotoOptions(validatorProvider: any): void {
    localStorage.setItem('currentValidatorProvider', JSON.stringify(validatorProvider));
    this.router.navigate(['/validators/options']);
  }
}
